// ============================================
// Normalización de texto a "Title Case"
// Convierte a minúsculas y pone la primera letra
// de cada palabra en mayúscula, para mantener
// orden y simetría en los datos guardados.
//
// Ejemplos:
//   "HILLARIE GIL"   → "Hillarie Gil"
//   "la planta"      → "La Planta"
//   "  jOSE  perez " → "Jose Perez"
// ============================================

export const capitalizarTexto = (str) => {
  if (str == null) return ''
  const s = String(str).trim()
  if (!s) return ''
  return s
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .map(p => p.charAt(0).toUpperCase() + p.slice(1))
    .join(' ')
}
